import script from "./ChatFollowupActions.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatFollowupActions.vue?vue&type=script&setup=true&lang=js"

import "./ChatFollowupActions.vue?vue&type=style&index=0&id=464a39fd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-464a39fd"]])

export default __exports__